<li class="nav-item dropdown-language dropdown me-2 me-xl-0 "
[ngClass]="generateClass()">
    <a id="change-language-button" class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown"
    ngbTooltip="{{'topMenu.language' | translate}}">
        <i class="fis rounded-circle  me-1" [ngClass]="thisCulture.icon+' '+classSize"></i>
    </a>
    <ul class="dropdown-menu dropdown-menu-end">
        <li *ngFor="let item of data.culture">
            <a class="dropdown-item" href="javascript:void(0);" (click)="changeCulture(item.shorCode)">
                <i class="fis rounded-circle fs-1 me-1" [ngClass]="item.icon"></i>
                <span class="align-middle">{{ item.name }}</span>
            </a>
        </li>
    </ul>
</li>

<input type="hidden" id="directionValue" [(ngModel)]="thisCulture.IsRightToLeft">
